import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { LocationStrategy } from '@angular/common';

import { jwtDecode } from 'jwt-decode';
import Swal from "sweetalert2";

import { EncryptionService } from 'src/app/services/encryption.service';
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';

@Component({
  selector: 'app-platform-legal',
  templateUrl: './platform-legal.component.html',
  styleUrls: ['./platform-legal.component.scss']
})
export class PlatformLegalComponent implements OnInit {


  legalForm!: FormGroup;
  Ttoken: any;
  decryptedData: any = []
  encryptOrgID: any;

  selectedFileName: string | null = null;
  public formfillNext: boolean = false;

  constructor(private locationStrategy: LocationStrategy,
    private fb: FormBuilder,
    private router: Router,
    private _ds: DataService,
    private route: ActivatedRoute,
    private enc: EncryptionService,
    private organizerSession: OrganizerSessionService
  ) {

  }

  ngOnInit(): void {

    // this.route.queryParamMap.subscribe(params => {
    //       const token = params.get('token');
    //       this.Ttoken = params.get('token');
    //       if (!token) return;

    //       const decoded = jwtDecode<OrganizerApprovalPayload>(token);

    //       console.log('FULL TOKEN 👉', decoded);

    //       this.organizer = decoded.organizer;

    //       console.log('Company 👉', this.organizer.id);
    //     });
    this.legalForm = this.fb.group({
      panNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
        ]
      ],
      panFile: [null, Validators.required]   // 🔥 file mandatory
    });


    // let PAN = localStorage.getItem('GSTIN');
    // if (PAN != null) {
    //   //  this.legalForm.get('panNumber')?.setValue(PAN);
    //   this.legalForm.patchValue({ panNumber: PAN });
    //   this.legalForm.get('panNumber')?.disable();
    // }
    this.route.queryParams.subscribe(params => {
      const id = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/platform-legal',
        this.router
      );
      if (id == null) return;

      this._ds.getUniqueUserData(id).subscribe((res: any) => {
        const allData = this.enc.decrypt(res.data);
        console.log(allData)

        if (allData.documents.pan_exists == true) {
          this.formfillNext = true

          const selectedNames = allData.documents.pan[0].pan_card_number; // ["Workshop", "Meetup"]
          const selectedNames2 = allData.documents.pan[0].document_path;
          // alert(allData.documents.pan[0].document_path)


          setTimeout(() => {
            this.legalForm.patchValue({
              panNumber: selectedNames,               // 👈 YAHI FIX HAI

            });
            this.selectedFileName = selectedNames2
          }, 500);

          Object.keys(this.legalForm.controls).forEach(key => {
            this.legalForm.get(key)?.disable();
          });

        } else {
          this.formfillNext = false

        }
      });
    });
  }

  onPanInput(event: Event) {
    const input = event.target as HTMLInputElement | null;

    if (!input) return;

    const value = input.value.toUpperCase();
    this.legalForm.get('panNumber')?.setValue(value, { emitEvent: false });
  }


  triggerFile() {
    const fileInput = document.getElementById('panFile') as HTMLElement;
    fileInput.click();
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  onFileSelect(event: any): void {
    const file = event.target.files?.[0];
    const control = this.legalForm.get('panFile'); 
    if (!control) return;

    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      this.legalForm.get('panFile')?.setErrors({ invalidType: true });
      this.selectedFileName = '';
      return;
    }

    // ✅ Max size: 3MB
    const maxSize = 3 * 1024 * 1024; // 3MB
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      control.markAsTouched();
      this.selectedFileName = '';
      event.target.value = '';
      return;
    }


    if (!file) {
      this.legalForm.get('panFile')?.setValue(null);
      return;
    }

    this.selectedFileName = file.name;

    // 🔥 form control ko set karo taaki validation pass ho
    this.legalForm.get('panFile')?.setValue(file);
    this.legalForm.get('panFile')?.markAsTouched();

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizerId =
      organizer?.id
        ? organizer.id
        : user?.organizer?.id
          ? user.organizer.id
          : null;

          const firstName =
  organizer?.first_name
    ? organizer.first_name
    : user?.organizer?.first_name
      ? user.organizer.first_name
      : null;

const lastName =
  organizer?.last_name
    ? organizer.last_name
    : user?.organizer?.last_name
      ? user.organizer.last_name
      : null;

    const formData = new FormData();
    formData.append('organizer_name', firstName + ' ' + lastName);
    formData.append('organizer_id', organizerId);
    formData.append('kyc_type', 'pan');
    formData.append('file', file);

    this._ds.uploadDoucment(formData).subscribe({
      next: (res: any) => {
        if (res?.data && typeof res.data === 'string') {
          this.decryptedData = this.enc.decrypt(res.data);
          console.log('✅ PAN upload success:', this.decryptedData);
        }
      },
      error: (err) => {
        console.log('❌ PAN upload error:', err);

        // 🔥 upload fail ho gaya → file invalid karo
        this.decryptedData = null;
        this.legalForm.get('panFile')?.setErrors({ uploadFailed: true });
      }
    });
  }



  submitted = false;

  submit() {
    this.submitted = true;
    this.legalForm.markAllAsTouched();   // 🔥 submit pe sab errors dikhenge

    // 🔥 PAN number ya file missing hai → API call band
    if (this.legalForm.invalid || !this.decryptedData?.url) {
      return;
    }

    const panNumber =
      this.legalForm.get('panNumber')?.disabled
        ? this.legalForm.getRawValue().panNumber
        : this.legalForm.value.panNumber;

    const payload = {
      document_type: "pan_card",
      pan_card_num: panNumber,
      document_path: this.decryptedData.url
    };

    console.log('FORM DATA 👉', payload);

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    let organizeID = {
      organizer_id: organizer?.id || user?.organizer?.id || null
    };

    this._ds.getDataOrganizerId(organizeID).subscribe({
      next: (res: any) => {
        this.encryptOrgID = this.enc.decrypt(res.data);

        this._ds.submitPANCard(this.encryptOrgID.url_safe_organizer_id, payload).subscribe({
          next: (res: any) => {
            if (res?.data) {
              const decryptedData = this.enc.decrypt(res.data);
              console.log('✅ Decrypted response:', decryptedData);
              this.router.navigate(['/platform-legal-organizer']);
            }
          },
          error: (err) => {
            if (err?.error?.data) {
              const decryptedData = this.enc.decrypt(err.error.data);
              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 1800,
                timerProgressBar: true,
              });
              Toast.fire({ title: decryptedData.error });
            }
          }
        });
      }
    });
  }


  PANcardVerification() {
    this.submitted = true;
    this.legalForm.markAllAsTouched();   // 🔥 submit pe sab errors dikhenge

    // 🔥 PAN number ya file missing hai → API call band
    if (this.legalForm.invalid || !this.decryptedData?.url) {
      return;
    }

    const panNumber =
      this.legalForm.get('panNumber')?.disabled
        ? this.legalForm.getRawValue().panNumber
        : this.legalForm.value.panNumber;

    const payload = {
      reference_id: "ref_12345",
      id_number: panNumber,
      consent: "Y",
      consent_purpose: "KYC PAN verification for onboarding"
    };

    // console.log('FORM DATA 👉', payload);

    // const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    // const user = JSON.parse(localStorage.getItem('user') || 'null');

    // let organizeID = {
    //   organizer_id: organizer?.id || user?.organizer?.id || null
    // };

    // this._ds.getDataOrganizerId(organizeID).subscribe({
    //   next: (res: any) => {
    //     this.encryptOrgID = this.enc.decrypt(res.data);

    this._ds.verifyPANDetails(payload).subscribe({
      next: (res: any) => {
        if (res?.data) {
          const decryptedData = this.enc.decrypt(res.data);
          console.log('✅ Decrypted response:', decryptedData);
          if (decryptedData.result.kycStatus == "SUCCESS") {
            // localStorage.setItem('PAN', decryptedData.result.kycResult.pan)
            this.submit()
            this.router.navigate(['/platform-legal-organizer']);
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 2800,
              timerProgressBar: true,
            });

            Toast.fire({ title: decryptedData.result.error.message });
          }
        }
      },
      error: (err) => {
        if (err?.error?.data) {
          const decryptedData = this.enc.decrypt(err.error.data);
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
          });
          Toast.fire({ title: decryptedData.error });
        }
      }
    });
    //   }
    // });
  }


  back() {
    // this.router.navigate(['/event-information']); 
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

    if (!orgType || !orgId) {
      console.error('❌ Organizer data missing in both user & organizer');
      return;
    }
    this.router.navigate(['/gst-registration'], { queryParams: { id: orgId } });

  }

  next() {
    const id = this.organizerSession.getSessionOrganizerId();
    if (id == null) return;
    this.router.navigate(['/platform-legal-organizer'], { queryParams: { id } });
  }

}
